import React from "react";

export const KeyIcon = () => {
   return  <svg
    width="58"
    height="54"
    viewBox="0 0 58 54"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle
      cx="18.7503"
      cy="35.1668"
      r="16.3333"
      fill="#7E869E"
      fill-opacity="0.25"
      stroke="#222222"
      stroke-width="4"
    />
    <path
      d="M31 22.9167L45.2917 8.625M51.4167 2.5L45.2917 8.625M45.2917 8.625L55.5 18.8333"
      stroke="#222222"
      stroke-width="4"
      stroke-linecap="round"
    />
  </svg>
}